<template>
  <div class="balance-container">
    <h2 class="balance-title">
      <AppIcon name="orangeCoin" size="lg" />
      余额充值中心
    </h2>

    <div class="balance-summary">
      <div class="balance-card current-balance">
        <div class="balance-amount-container">
          <div class="balance-amount">{{ goldAmount }} 橘子币</div>
          <div class="balance-label">当前余额</div>
        </div>
        <AppIcon name="orangeCoin" size="xl" />
      </div>

      <div class="balance-card total-spent">
        <div class="balance-amount-container">
          <div class="balance-amount">{{ totalConsumeAmount }} 橘子币</div>
          <div class="balance-label">累计消费</div>
        </div>
        <AppIcon name="totalSpend" size="xl" aria-label="累计消费" />
      </div>
    </div>

    <div class="recharge-description">
      充值项目（充值比例：1 元 = 50 橘子币）
    </div>

    <div v-if="listLoading" class="recharge-description">加载档位中...</div>
    <div v-else class="recharge-options">
      <button
        v-for="pkg in packages"
        :key="pkg.code"
        type="button"
        :class="['recharge-button', { selected: selectedPackageCode === pkg.code }]"
        @click="selectPackage(pkg.code)"
      >
        <div class="recharge-amount">{{ pkg.grantGold }} 橘子币</div>
        <div class="recharge-price">¥{{ pkg.payYuan }}</div>
        <div v-if="pkg.firstRechargeBonusGold > 0" class="recharge-price">
          含加赠 {{ pkg.firstRechargeBonusGold }}
        </div>
        <AppIcon
          v-if="selectedPackageCode === pkg.code"
          name="check"
          size="md"
          class="check-icon"
          aria-label="已选"
        />
      </button>
    </div>

    <div class="payment-options">
      <span class="payment-amount">支付金额：¥{{ selectedPackage?.payYuan || '0.00' }}</span>
      <button type="button" class="mika-payment-button" :disabled="!selectedPackageCode" @click="openRechargePay">
        微信支付
      </button>
    </div>
    <p v-if="errorMessage" class="balance-error">{{ errorMessage }}</p>
    <button type="button" class="balance-agree-link" @click="openGoldAgreement">
      {{ agreementTitle }}
    </button>

    <div class="recharge-info">
      <div class="recharge-description">
        <ul>
          <li>充值说明：</li>
          <li>充值比例为 1 元 = 50 橘子币</li>
          <li>实际到账以所选档位为准（含首充加赠）</li>
          <li>余额永久有效，无时间限制</li>
          <li>成功充值后暂不支持退款</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useBalance } from '@/features/user/composables/useBalance'

const {
  selectedPackageCode,
  selectedPackage,
  packages,
  listLoading,
  errorMessage,
  agreementTitle,
  goldAmount,
  totalConsumeAmount,
  selectPackage,
  openRechargePay,
  openGoldAgreement,
} = useBalance()
</script>

<style scoped src="@/features/user/styles/operationArea/Balance.css"></style>
